import { Button } from '@/shared/ui/Button'
import { MobileSheet } from '@/shared/ui/MobileSheet'
import { useTranslation } from '@/shared/hooks/useTranslation'

type BonusRedemptionSheetProps = {
  open: boolean
  bonusName: string
  coinsAmount: number
  redeemState: 'idle' | 'loading' | 'success'
  creditedCoins: number | null
  alreadyRedeemed?: boolean
  onClose: () => void
  onRedeem: () => void
}

export const BonusRedemptionSheet = ({
  open,
  bonusName,
  coinsAmount,
  redeemState,
  creditedCoins,
  alreadyRedeemed = false,
  onClose,
  onRedeem
}: BonusRedemptionSheetProps) => {
  const { t } = useTranslation()

  const isSuccess = redeemState === 'success' || alreadyRedeemed
  const isLoading = redeemState === 'loading'
  const creditedAmount = creditedCoins ?? coinsAmount

  return (
    <MobileSheet
      open={open}
      onClose={onClose}
      title={t('bonus.sheetTitle')}
      ariaLabel={t('bonus.sheetTitle')}
      footer={
        <Button
          variant={isSuccess ? 'success' : 'primary'}
          className="w-full"
          disabled={isLoading || isSuccess}
          onClick={onRedeem}
          showTrailingIcon={false}
        >
          {isSuccess
            ? t('bonus.redeemed')
            : isLoading
              ? t('bonus.redeeming')
              : t('bonus.redeem')}
        </Button>
      }
    >
      <div className="px-4 pb-6 text-center">
        <p className="text-lg font-bold text-gray-900 mb-2">{bonusName}</p>
        <p className="text-sm text-gray-700 mb-0">
          {isSuccess
            ? t('bonus.alreadyRedeemedPreview', { coins: coinsAmount })
            : t('bonus.rewardPreview', { coins: coinsAmount })}
        </p>
        {redeemState === 'success' ? (
          <p className="mt-3 mb-0 text-sm font-semibold text-green-700">
            {t('bonus.successInline', { coins: creditedAmount })}
          </p>
        ) : null}
      </div>
    </MobileSheet>
  )
}
